export default __webpack_public_path__ + "static/media/currency.9019acb7.svg";